module.exports = __webpack_public_path__ + "static/media/news_head_bg_3.572fd30e.jpg";